/**
 * @desc 获取所有模型
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<defs.activiti.PageInfo<defs.activiti.Model>>;
export function request(
  params: API.activiti.activiti.modelList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activiti/modelList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
